export enum FILTER_ACTIONS {
    SET_AVAILABLE_AREA_FILTER_OPTIONS = 'FILTER_SET_AVAILABLE_AREA_FILTER_OPTIONS',
    SET_AVAILABLE_CLIENT_TYPE_FILTER_OPTIONS = 'FILTER_SET_AVAILABLE_CLIENT_TYPE_FILTER_OPTIONS',
    SET_BOUNDS_BUDGET_FILTER = 'FILTER_SET_BOUNDS_BUDGET_FILTER',
    SET_SELECTED_AREA_FILTER = 'FILTER_SET_SELECTED_AREA_FILTER',
    SET_SELECTED_CLIENT_TYPE_FILTER = 'FILTER_SET_SELECTED_CLIENT_TYPE_FILTER',
    SET_SELECTED_BUDGET_FILTER = 'FILTER_SET_SELECTED_BUDGET_FILTER',
    CLEAR_SELECTED_FILTERS = 'FILTER_CLEAR_SELECTED_FILTER'
}
